import axios from 'axios';
import { Fragment } from 'react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useQuery } from 'react-query';
import OutsideClickHandler from '../../../SharedComponents/OutsideClickHandler';
import { getPages } from './ApiPage';

export default function ProgramList(props) {
  //TODO
  //   Error while searching by name
  const { languageId, setFieldValue, programId } = props;
  const [isOpen, setIsOpen] = useState(false);
  const [searchParam, setSearchParam] = useState('');
  const { t } = useTranslation();
  const onSearchParam = (e) => {
    setSearchParam(e.target.value);
  };
  const PagesinitialData = {
    pageNumber: 1,
    pageSize: 1,
    isPaging: false,
    langId: languageId,
  };
  // Query Data To Fetch Languages
  const { data, isLoading, isError } = useQuery(['programs', PagesinitialData], getPrograms, {
    staleTime: 360000000,
  });
  if (isLoading) return '';
  if (isError) return 'error';
  console.log('data', data);
  const onClick = (data) => {
    setFieldValue('programId', data.id);
    setIsOpen(false);
  };
  let defaultValue = data.data.find((e) => e.id === programId);
  return (
    <div className="relative">
      <label>
        <span>{t('Program')}</span>
        <input
          onFocus={() => {
            setIsOpen(true);
          }}
          onChange={onSearchParam}
          className="border rounded  w-full mb-0 p-1"
          value={defaultValue?.programLngs[0].name}
        />
      </label>

      {isOpen && (
        <OutsideClickHandler setIsOpen={setIsOpen}>
          <div className="absolute bottom-0 z-50 left-0 bg-white w-full transform translate-y-full pl-0 block ">
            <ul className="border rounded divide-y overflow-y-scroll max-h-64 mt-2">
              {data.data
                .filter((e) => e.programLngs[0]?.name.toLowerCase().includes(searchParam.toLowerCase()))
                .map((e) => {
                  return (
                    <Fragment key={e.id}>
                      <button
                        onClick={(x) => {
                          onClick(e);
                        }}
                        type="button"
                        className={`${
                          programId === e.id ? 'bg-darkbluehover text-white' : ''
                        } w-full text-left block px-2 py-1 hover:bg-darkbluehover hover:text-white`}
                      >
                        {e.programLngs.map((x) => {
                          return <>{languageId === x.languageId && x.name}</>;
                        })}
                      </button>
                    </Fragment>
                  );
                })}
            </ul>
          </div>
        </OutsideClickHandler>
      )}
    </div>
  );
}

export const getPrograms = async (e) => {
  const query = await axios.post('/Program/GetAll', e.queryKey[1]);
  const data = query.data.data;
  const isDone = query.data.isDone;
  const paginationResult = query.data.paginationResult;
  return { data, isDone, paginationResult };
};
